<template>
  <!-- Google Pay 按钮 -->
  <div id="googlePay" v-if="orderDetails">
    <google-pay-button
      v-if="paymentRequest"
      ref="googlePay"
      :environment="env"
      button-type="buy"
      button-color="black"
      button-size-mode="fill"
      :paymentRequest.prop="paymentRequest"
      @loadpaymentdata="onLoadPaymentData($event, httpGoogleDecryptToken)"
      @error="onError($event, setErrorTips)"
    ></google-pay-button>
  </div>
</template>

<script>
import '@google-pay/button-element'
import { postGoogleDecryptToken } from '@/views/checkout/api/google-pay'
import { postPaymentLogger } from '@/views/checkout/api'
import { toTransactionResult } from '@/views/checkout/tools'

export default {
  props: {
    order: {
      type: Object,
      default: () => ({})
    },
    getFromData: {
      type: Function,
      default: () => {}
    },
    setErrorTips: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      orderId: this.$route.params.id,
      orderDetails: this.$props.order,
      env: this.$props.order?.wg?.google?.env,
      setResponseTips: null,
      paymentRequest: null
    }
  },
  methods: {
    httpGoogleDecryptToken(event) {
      this.$emit('loading', true)
      if (event?.detail) {
        // 发送商户验证请求到后端
        postGoogleDecryptToken(this.orderId, {
          ...event.detail,
          ...this.getFromData()
        })
          .then((response) => {
            toTransactionResult(this, response, this.orderId)
            const count = setTimeout(() => {
              this.$emit('loading', false)
              clearTimeout(count)
            }, 500)
          })
          .catch((error) => {
            this.setErrorTips(error.message)
            postPaymentLogger(error, this.orderId, 'Google Pay Decrypt Token Error')
          })
      } else {
        this.$emit('loading', false)
      }
    },
    onLoadPaymentData: (event, httpGoogleDecryptToken) => {
      httpGoogleDecryptToken(event)
    },
    onError: (event, setErrorTips) => {
      setErrorTips(event?.error?.statusMessage)
    }
    // onPaymentDataAuthorized: (paymentData) => {
    //   console.log('payment authorized', paymentData)
    //   return {
    //     transactionState: 'SUCCESS'
    //   }
    // },
    // onReadyToPayChange: (event) => {
    //   console.log('ready to pay change', event.detail)
    // }
  },
  mounted() {
    this.paymentRequest = {
      apiVersion: 2,
      apiVersionMinor: 0,
      allowedPaymentMethods: [
        {
          type: 'CARD',
          parameters: {
            allowedAuthMethods: (this.orderDetails?.wg?.google?.authMethod || 'PAN_ONLY,CRYPTOGRAM_3DS').split(','),
            allowedCardNetworks: ['AMEX', 'DISCOVER', 'JCB', 'MASTERCARD', 'VISA'],
            billingAddressRequired: true,
            billingAddressParameters: {
              format: 'FULL',
              phoneNumberRequired: true
            }
          },
          tokenizationSpecification: {
            type: 'PAYMENT_GATEWAY',
            parameters: {
              gateway: this.orderDetails?.wg?.google?.gatewayId,
              gatewayMerchantId: this.orderDetails?.wg?.google?.merNo
            }
          }
        }
      ],
      merchantInfo: {
        merchantId: this.orderDetails?.wg?.google?.merchantId,
        merchantName: this.orderDetails?.wg?.google?.merchantName
      },
      transactionInfo: {
        totalPriceStatus: 'FINAL',
        totalPriceLabel: this.$t('message.checkout.orderAmount'),
        totalPrice: String(this.orderDetails?.price).trim(),
        // 国家码优先取账单表单中选择的值，其次取订单预设值
        countryCode:
          this.getFromData()?.billingAddress?.country ||
          this.orderDetails?.billing?.country ||
          this.orderDetails?.paymentCountry,
        currencyCode: this.orderDetails?.currency
      },
      emailRequired: true
    }
    postPaymentLogger(this.paymentRequest, this.orderId, 'Google Pay Payment Request Data')
  }
}
</script>

<style lang="less" scoped>
@import '~@/styles/custom.less';

#googlePay {
  google-pay-button {
    .pay-button();
    height: 50px;
    padding: 0;
  }
}
</style>
